import React from 'react';
import { CartesianGrid, ResponsiveContainer, Scatter, ScatterChart, XAxis, YAxis } from 'recharts';

function HistoryChart({ data }) {
    const ticksArr = data.map(el => el.count);
    const colorArr = ["#0A2B83", "#45BFCE", "#2CB6B3", "#0070C0", "#0F9ED5"];
    const domain = data.length > 0 ? [data[0]["count"], data[data.length - 1]["count"]] : [0, 10];
    return (
        <ResponsiveContainer>
            <ScatterChart
                data={data}
                padding={{ left: 20, right: 20 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis
                    ticks={data.length > 0 ? null : [0, 10, 20, 30, 40, 50]}
                    domain={data.length > 0 ? null : [0, 50]}
                    // interval={0}
                    width={34}
                    tickMargin={6}
                    tickSize={8}
                />
                <XAxis
                    type='category'
                    dataKey={"count"}
                    height={14}
                    domain={domain}
                    // interval={data[0]?.count >= 100 ? 1 : 0}
                    interval={0}
                    tick={({ x, y, payload, index }) => {
                        const total = data.length;
                        const showTick = (
                            data[data.length - 1]?.count < 100 ||
                            (total % 2 === 1 && index % 2 === 0) || // 홀수 개면 0,2,4,...
                            (total % 2 === 0 && index % 2 === 1) || // 짝수 개면 1,3,5,...
                            index === total - 1 // 마지막은 무조건 표시
                        );

                        return showTick ? (
                            <text x={x} y={y + 10} textAnchor="middle" fill="#666">
                                {payload.value}
                            </text>
                        ) : null;
                    }}
                    tickLine={false}
                    ticks={data.length > 0 ? ticksArr : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                    tickFormatter={(val) => val.toString()}
                />
                {
                    data.length > 0 ?
                        Object.keys(data[data.length - 1]).map((key, idx) => {
                            if (key !== "dataId" && key !== "count") {
                                return (
                                    <Scatter
                                        key={`scatt_${idx}`}
                                        dataKey={key}
                                        fill={colorArr[idx - 2]}
                                    />
                                )

                            }
                        })
                        : null
                }

            </ScatterChart>
        </ResponsiveContainer>
    );
}

export default HistoryChart;